import { render, staticRenderFns } from "./addedition.vue?vue&type=template&id=0527a31a&scoped=true&"
import script from "./addedition.vue?vue&type=script&lang=js&"
export * from "./addedition.vue?vue&type=script&lang=js&"
import style0 from "./addedition.vue?vue&type=style&index=0&id=0527a31a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0527a31a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0527a31a')) {
      api.createRecord('0527a31a', component.options)
    } else {
      api.reload('0527a31a', component.options)
    }
    module.hot.accept("./addedition.vue?vue&type=template&id=0527a31a&scoped=true&", function () {
      api.rerender('0527a31a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/editionInstructions/components/addedition.vue"
export default component.exports